"use client";

import React, { JSX, useEffect } from "react";
import Head from "next/head";

function Meta({
  title,
  description,
}: {
  title: string;
  description?: string;
}): JSX.Element | null {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let metaDescription = document.querySelector(
        "meta[name='description']",
      ) as HTMLMetaElement | null;

      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      if (metaDescription) {
        metaDescription.content = description;
      }
    }
  }, [title, description]);

  return (
    <Head>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
    </Head>
  );
}

export default Meta;
